<template>
    <transition name="fade">
        <div v-if="showModal" class="switch-school-modal">
            <div @click="$emit('close')" class="modal-backdrop p-4"></div>
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="shadow-text-none">{{ $t('switch_school_modal_header') }}</h1>
                </div>
                <div class="modal-body">
                    <XButton
                        v-for="(school, index) in schools"
                        @click="schoolSelect = school.user_id"
                        :key="index"
                        :class="{ 'school-select': true, active: schoolSelect === school.user_id }"
                        :color="schoolSelect === school.user_id ? 'var(--button-background-color)' : '#000'"
                        bg-color="#fff"
                        font-weight="normal"
                    >
                        <span class="shadow-text-none">{{ school.name }}</span>
                        <i v-if="schoolSelect === school.user_id" class="fas fa-check shadow-text-none"></i>
                    </XButton>
                </div>
                <div class="modal-footer">
                    <XButton
                        @click="switchAccount()"
                        :disabled="switching"
                        bg-color="var(--button-background-color)"
                        color="var(--button-text-color)"
                    >
                        {{ $t('switch_school_modal_button') }}
                    </XButton>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { currentUser } from '@/lib/user'
import UserService from '@/lib/user.js'
import XButton from '@/components/v2/XButton'

export default {
    components: {
        XButton
    },

    data() {
        return {
            showModal: false,
            schools: currentUser().schools,
            schoolSelect: currentUser().id,
            switching: false
        }
    },

    methods: {
        openModal() {
            this.showModal = true
        },

        async switchAccount() {
            if (this.switching) return

            this.switching = true

            if (this.schoolSelect === currentUser().id) {
                this.$emit('close')
                this.switching = false
                return
            }

            const newUser = await this.$store.dispatch('switchAccount', {
                switch_to: this.schoolSelect
            })

            const userService = new UserService()
            userService.setToken(newUser.token)

            location.reload()
        }
    }
}
</script>

<style lang="scss">
.switch-school-modal {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .modal-backdrop {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
    }

    .modal-content {
        position: relative;
        max-width: 400px;
        width: 100%;
        background-color: #fff;
        border-radius: 6px;

        .modal-header {
            padding: 14px 14px 0 14px;

            h1 {
                font-size: 17.5px;
                margin: 0;
            }
        }

        .modal-body {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            row-gap: 14px;
            padding: 14px;

            .school-select {
                justify-content: space-between;
                width: 100%;
                height: auto;
                padding: 14px;
                border: 1px solid #ccc;
                border-radius: 6px;
                font-size: 14px;

                &.active {
                    border-color: var(--button-background-color);
                    color: var(--button-background-color);
                }
            }
        }

        .modal-footer {
            padding: 0 14px 14px 14px;

            button {
                width: 100%;
                border-radius: 6px;
                font-size: 14px;
            }
        }
    }
}
</style>